<template>
  <div class="product_box">
    <!-- banner -->
    <img class='banner' src="../../assets/images/about/banner.png" alt="">

    <!-- 内容盒子 -->
    <div class="type_area product">
      <!-- 单项产品分类 -->
      <div v-for="(item,index) in home" :key="index" class="product1 col-xs-6 col-sm-3" v-loading>
        <img :src='item.typeimg' alt>
        <p class="title">{{item.typename}}</p>
        <p class="btn" @click='skip(item.id)'>Browse</p>
        <p class="text">{{item.description}}</p>
      </div>


    </div>
  </div>
</template>


<script>
export default {
  data:function() {
      return {
          home:[]
      };
  },
  methods: {
    // 跳转到二级产品页面
    skip(e){
      this.$router.push({ path:'/classify'+'?id='+e})
    }
  },
  mounted() {
      this.$http.get("/api/home.php").then((res)=>{
          this.home = res.data.data;
      })
  }

};
</script>



<style scoped lang="less">
// 产品页面
.product_box {
  margin: 3rem 0 0;
  background: #f0f2f5;
  min-height: 45.5rem;
  
  .banner{
    width:100%;
  }

  // 所有产品盒子
  .product {
      display:flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 2rem;

    // 单个产品盒子
    .product1 {
      width:13rem;
      height:13rem;
      margin-bottom: 2rem;
      padding: 0;
      display: flex;
      justify-content: center;

      font-size: 1.4rem;

      img {
        width: 100%;
      }
      p {
        margin: 0;
        padding: 0;
      }

      // 蒙层
      .model {
        width: 100%;
        height: 12rem;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.3);
      }

      // 产品分类
      .title {
        width:100%;
        position: absolute;
        top: 1rem;
        color: #fff;
        padding: 0 1rem;
        box-sizing: border-box;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;

        font-weight:bold;
        text-shadow: 0 0 10px rgb(151, 4, 4);
      }
      // 分类按钮
      .btn {
        position: absolute;
        top: 5rem;
        border-radius: 1rem;
        padding: 0.2rem 0.8rem;
        box-sizing: border-box;
        z-index: 999;
        color: #000000;

        box-shadow: 0 0 3px 3px #257CE1;
        font-weight:bold;
      }

      // 描述文本
      .text {
        position: absolute;
        bottom: 1.5rem;
        width: 100%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-align: center;
        padding: 0 1rem;

        font-weight:bold;
      }
    }
  }
}
</style>